
(function() {
    'use strict';

    angular.module( APP_ID )
    .component( 'categoriesListing', {
        templateUrl:  'app/views/partials/content/categories-listing.html',
        controller:   CategoriesListingController,
        controllerAs: 'vm',
    });


    /**
     * Lists out all existing areas and qualifications.
     *
     * @param {ng.IScope} $scope
     * @param {DataService} DataService
     * @param {MetaService} MetaService
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function CategoriesListingController(
        $scope,
        DataService,
        MetaService,
        TEXTS,
        CONFIG
    ){
        /** @type {angular.IController} */
        var vm = this;





        /* ===== EXPOSE TO THE SCOPE ======================================== */


        $scope._        = TEXTS.EXPLORE;
        $scope.CONFIG   = CONFIG;




        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        (function init() {

            MetaService.resetToDefaults();
            MetaService.updateTitleStructure({
                page: $scope._.META_TITLE
            });

            MetaService.updateDescriptionStructure({
                page: $scope._.META_DESCRIPTION
            });

            DataService.getCategoriesListing().then( function( response ){
                vm.categories = response;

                vm.isLoading      = false;
            }).catch( function( errMsg ) {
                vm.errMsg = errMsg;

                vm.isLoading = false;
            });

        })();
    }


    CategoriesListingController.$inject  = [ '$scope', 'DataService', 'MetaService', 'TEXTS', 'CONFIG' ];

})();
